// A jquery version of MDN's recommended pattern for WCAG accessible tabs >> https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role
(function($) {
    $.fn.rlTabbedPanel = function() {
        $('.tabbed-panel').each(function(){
            var $container = $(this);
            var $tabs = $container.find('[role="tab"]');
            var $tabpanels = $container.find('[role="tabpanel"]');

            $container.on('rl-tabbed-panel-changed', function(e, $tabToShow, scrollToTop){

                // unhighlight tabs and hide panels.
                $tabs.attr('aria-selected', false);
                $tabpanels.attr('hidden', true);

                // highlight active tab/panel.
                $tabToShow.attr('aria-selected', true);
                $('#' + $tabToShow.attr('aria-controls')).removeAttr('hidden');

                // update tabindex of tabs.
                var focusTabIndex = $tabs.index($tabToShow);
                $tabs.attr('tabindex', -1);
                $tabs.eq(focusTabIndex).attr('tabindex', 0);

                // scroll top of tab pane into view.
                if (scrollToTop) {
                    var scrollTo = $tabpanels.eq(focusTabIndex).offset().top - $('#header').height();

                    if (scrollTo < $(window).scrollTop()) {
                        $('html, body').animate({
                            scrollTop: $tabpanels.eq(focusTabIndex).offset().top - $('#header').height()
                        });
                    }
                }

            });

            $tabs.on('click', function(e){

                // Bugfix: Episerver preview mode scrolls back to the top, when the DOM body height changes.
                if ( window.location !== window.parent.location ) {
                    var _this = this;
                    setTimeout(function(){
                        _this.scrollIntoView();
                    }, 800)
                }
                
                $container.trigger(
                    'rl-tabbed-panel-changed',
                    [$(this), true]
                );
            });

            $tabs.on('keydown', function(e){

                if ([38,40].indexOf(e.keyCode) === -1) return;

                e.preventDefault();

                var focusTabIndex = $tabs.index(e.currentTarget);

                // arrow up
                if(e.keyCode === 38) {
                    focusTabIndex = (focusTabIndex !== 0) ? focusTabIndex - 1 : $tabs.length - 1;
                }

                // arrow down
                if(e.keyCode === 40) {
                    focusTabIndex = (focusTabIndex + 1 < $tabs.length) ? focusTabIndex + 1 : 0;
                }

                $tabs.eq(focusTabIndex).focus().click();
            });

            // display the first tab.
            $container.trigger('rl-tabbed-panel-changed', [$tabs.eq(0), false]);
        });

    }
}(jQuery));